import { academicProfile } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IAcademicDetails } from "../../models/student/studentAcademicProfile";

export default new (class AcademicProfileService {
  public getAcademicDetails = async (
    id: string
  ): Promise<IApiResponse<IAcademicDetails>> => {
    try {
      let endPoint = urlBinder(academicProfile.GET_ACADEMIC_DETAILS, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IAcademicDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IAcademicDetails>;
      } else {
        throw error;
      }
    }
  };

  public updateAcademicDetails = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(academicProfile.UPDATE_ACADEMIC_DETAILS, [
        `${id}`,
      ]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };
})();
